SppHandler = App.loadClass 'grower::handlers/placement/SppHandler'

class exports.MyFarmsSPPHandler extends SppHandler

    # This function will be passed into the Planting dialog controller via
    # PlantingOptions. "plan" is the Layer model used for the Plan tab.
    # "notes_obj" is the object used by the Notes tab.
    customPlantingPlan: (field_id, plan, notes_obj) =>
        # nothing to customize
        return
